export default __webpack_public_path__ + "static/logo-black-d5c3317c19b5d849c5283fd70eb253ee.svg";